import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';

const getClientRsps = store => async (state, clientId) => {
    const userClientId = state.user.selectedUserClientId;

    const endpoint = `/clients/${clientId}/rsps`;
    const response = await sportsApi
        .url(endpoint)
        .get()
        .json();

    const rsps = response.reduce(
        (acc, el) => {
            const { rightsholder, sponsor, placement } = el;
            const rh = acc.rightsholders.find(e => e.id === rightsholder.id);
            if (!rh) {
                acc.rightsholders.push({
                    id: rightsholder.id,
                    name: rightsholder.name,
                    placements: [
                        {
                            id: placement.id,
                            name: placement.name,
                            sponsors: [
                                {
                                    id: sponsor.id,
                                    name: sponsor.name,
                                },
                            ],
                        },
                    ],
                });
            } else {
                const pl = rh.placements.find(e => e.id === placement.id);
                if (!pl) {
                    rh.placements.push({
                        id: placement.id,
                        name: placement.name,
                        sponsors: [
                            {
                                id: sponsor.id,
                                name: sponsor.name,
                            },
                        ],
                    });
                } else {
                    pl.sponsors.push({
                        id: sponsor.id,
                        name: sponsor.name,
                    });
                }
            }
            return acc;
        },
        { rightsholders: [] },
    );

    store.setState(
        R.assocPath(
            ['clients', userClientId, 'settings', 'client', 'rsps'],
            rsps,
            store.getState(),
        ),
        true,
    );
};

export default getClientRsps;
